import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { from, Observable } from 'rxjs';
import { jsDocComment } from '@angular/compiler';
import { environment } from 'src/environments/environment';
import { catchError } from "rxjs/operators";
import { HandleHttpError } from 'src/app/core/utils/HttpHandleError';

@Injectable()
export class NeoIntermediarioFinancieroService {
  public url: String;

  constructor(private _http: HttpClient) {
    this.url = environment.apiLocalUrl + 'intermediarioFinanciero/services';
  }

  getValidarLineas(idCliente){
    return this._http.get(environment.apiLocalUrl + 'parametros/servicios/lineas/validacion/' + idCliente).pipe(catchError(HandleHttpError));
  }

  login(body: any) {
    return this._http.post(`${this.url}/login`, body).pipe(catchError(HandleHttpError)).toPromise();
  }

  saveUsuario(usuarioXrol): Observable<any> {
    let body = JSON.stringify(usuarioXrol);
    let headers = new HttpHeaders().set('Content-type', 'application/json');

    return this._http.post(this.url + '/registro', body, { headers: headers }).pipe(catchError(HandleHttpError));
  }

  getSolicitudesPendientesIF(idCliente): Observable<any> {
    return this._http.get(this.url + '/solicitudesPendientes/' + idCliente).pipe(catchError(HandleHttpError));
  }

  negarSolicitud(solicitudNegada): Observable<any> {
    let body = JSON.stringify(solicitudNegada);
    let headers = new HttpHeaders().set('Content-type', 'application/json');

    return this._http.post(this.url + '/negarSolicitud', body, {
      headers: headers,
    }).pipe(catchError(HandleHttpError));
  }

  crearPropuesta(neoPropuestaIntermediario): Observable<any> {
    let body = JSON.stringify(neoPropuestaIntermediario);
    let headers = new HttpHeaders().set('Content-type', 'application/json');

    return this._http.post(this.url + '/crearPropuesta', body, {
      headers: headers,
    }).pipe(catchError(HandleHttpError));
  }

  coutaRecursosPropios(datosCuotaRecPropios) {
    let body = JSON.stringify(datosCuotaRecPropios);
    let headers = new HttpHeaders().set('Content-type', 'application/json');

    return this._http.post(this.url + '/cuota', body, {
      headers: headers,
    }).pipe(catchError(HandleHttpError));
  }

  aceptarSolicitud(datosAceptarSolicitud) {
    let body = JSON.stringify(datosAceptarSolicitud);
    let headers = new HttpHeaders().set('Content-type', 'application/json');

    return this._http.post(this.url + '/aceptarSolicitud', body, {
      headers: headers,
    }).pipe(catchError(HandleHttpError));
  }

  negarSolicitudAprobador(datosNegarSolicitudAprobador) {
    let body = JSON.stringify(datosNegarSolicitudAprobador);
    let headers = new HttpHeaders().set('Content-type', 'application/json');

    return this._http.post(this.url + '/negarSolicitudAprobador', body, {
      headers: headers,
    }).pipe(catchError(HandleHttpError));
  }

  devolverSolicitud(datosDevolverSolicitud) {
    let body = JSON.stringify(datosDevolverSolicitud);
    let headers = new HttpHeaders().set('Content-type', 'application/json');

    return this._http.post(this.url + '/devolverSolicitud', body, {
      headers: headers,
    });
  }

  detalleAprobador(datosDetalleAprobador) {
    let body = JSON.stringify(datosDetalleAprobador);
    let headers = new HttpHeaders().set('Content-type', 'application/json');

    return this._http.post(this.url + '/solicitud/detalleAprobador', body, {
      headers: headers,
    }).pipe(catchError(HandleHttpError));
  }

  getMotivosDevolucion(): Observable<any> {
    return this._http.get(this.url + '/motivosDevolucion').pipe(catchError(HandleHttpError));
  }

  getTasaBancoldex(idModalidad): Observable<any> {
    return this._http.get(this.url + '/tasaBancoldex/ ' + idModalidad).pipe(catchError(HandleHttpError));
  }

  getFiltrarSolicitud(filtroDTO): Observable<any> {
    let body = JSON.stringify(filtroDTO);
    let headers = new HttpHeaders().set('Content-type', 'application/json');

    return this._http.post(this.url + '/filtrarSolicitud', body, {
      headers: headers,
    }).pipe(catchError(HandleHttpError));
  }

  getUsuarioIntermediario(idUsuario, idUsuarioConsultor): Observable<any> {
    return this._http.get(
      this.url + '/consultarUsuario/' + idUsuario + '/' + idUsuarioConsultor
    ).pipe(catchError(HandleHttpError));
  }

  getFilterUsuarios(datosFiltro) {
    let body = JSON.stringify(datosFiltro);
    let headers = new HttpHeaders().set('Content-type', 'application/json');

    return this._http.post(this.url + '/filtrarUsuarios', body, {
      headers: headers,
    }).pipe(catchError(HandleHttpError));
  }

  consultarPerfiles(datosFiltrousuarios): Observable<any> {
    let body = JSON.stringify(datosFiltrousuarios);
    let headers = new HttpHeaders().set('Content-type', 'application/json');

    return this._http.post(this.url + '/consultarPerfiles', body, {
      headers: headers,
    }).pipe(catchError(HandleHttpError));
  }

  dowloadExcelPerfiles(body: any) {
    return this._http.post(`${this.url}/generarExcelConsultaPerfiles`, body).pipe(catchError(HandleHttpError));
  }

  dowloadTxtPerfiles(body: any) {
    return this._http.post(`${this.url}/generarTxtConsultaPerfiles`, body).pipe(catchError(HandleHttpError));
  }

  obtenerEntidades(): Observable<any> {
    return this._http.get(`${this.url}/consultarEntidades`).pipe(catchError(HandleHttpError));
  }

  consultarRolesNoUtilizados(body: any): Observable<any> {
    return this._http.post(`${this.url}/consultaRolesNoUtilizados`, body).pipe(catchError(HandleHttpError));
  }

  dowloadExcelRolesNoUtilizados(body: any) {
    return this._http.post(`${this.url}/generarExcelRolesNoUtilizados`, body).pipe(catchError(HandleHttpError));
  }

  dowloadTxtRolesNoUtilizados(body: any) {
    return this._http.post(`${this.url}/generarTxtRolesNoUtilizados`, body).pipe(catchError(HandleHttpError));
  }

  confirmarDesembolso(datosConfirmarDesembolso) {
    let body = JSON.stringify(datosConfirmarDesembolso);
    let headers = new HttpHeaders().set('Content-type', 'application/json');

    return this._http.post(this.url + '/confirmarDesembolso/recursosPropios', body, {
      headers: headers,
    }).pipe(catchError(HandleHttpError));
  }

  confirmarDesembolsoBx(body: any) {
    return this._http.post(`${this.url}/confirmarDesembolso/recursosBancoldex`, body).pipe(catchError(HandleHttpError));
  }

  negarDesembolso(datosNegarDesembolso) {
    let body = JSON.stringify(datosNegarDesembolso);
    let headers = new HttpHeaders().set('Content-type', 'application/json');

    return this._http.post(this.url + '/negarDesembolso', body, {
      headers: headers,
    }).pipe(catchError(HandleHttpError));
  }
  getTipos(): Observable<any> {
    return this._http.get(
      this.url + '/TipoPersonaJuridica/tiposPersonaJuridica'
    ).pipe(catchError(HandleHttpError));
  }

  getTiposPersona(idCliente): Observable<any> {
    return this._http.get(
      this.url + '/TipoPersonaJuridica/' + idCliente
    ).pipe(catchError(HandleHttpError));
  }

  guardarCambios(body): Observable<any> {
    return this._http.put(
      `${this.url}/TipoPersonaJuridica/actualizarTipoPersonaJuridica`, body
    ).pipe(catchError(HandleHttpError));
  }

  // Centrales de riesgo
  saveCentralesRiesgo(body:any){
    return this._http.post(`${this.url}/confCentralesRiesgo/crear`, body)
    .pipe(catchError(HandleHttpError));
  }

  updateCentralesRiesgo(body:any){
    return this._http.post(`${this.url}/confCentralesRiesgo/actualizar`, body)
    .pipe(catchError(HandleHttpError));

  }

  obtenerParametrosCRByCliente(idCliente:number){
    return this._http.get(
      `${this.url}/confCentralesRiesgo/obtener/${idCliente}`
    ).pipe(catchError(HandleHttpError));
  }

  obtenerSectoresCR(){
    return this._http.get(
      `${this.url}/sectores`
    ).pipe(catchError(HandleHttpError));
  }
  // Economia popular
  getMensajeEconomiaPopular(idSolicitud:string){
    return this._http.get(
      `${this.url}/economiaPopular/${idSolicitud}`
    ).pipe(catchError(HandleHttpError));
  }

  getSolicitudAvanceFormalizacion(idSolicitudIntermediario:number){
    return this._http.get(
      `${this.url}/avanceFormalizacion/${idSolicitudIntermediario}`
    ).pipe(catchError(HandleHttpError));
  }

  saveObservacionesAvanceFormalizacion(body:any){
    return this._http.post(
      `${this.url}/avanceFormalizacion/guardar`, body
    ).pipe(catchError(HandleHttpError));
  }

  getListDepartamentosUbicaciones(idCliente){
    return this._http.get(`${this.url}/departamentosCliente/` + idCliente).pipe(catchError(HandleHttpError));
  }
  
  getParametrizacionBuro(idIntermediarioFinanciero){
    return this._http.get(`${this.url}/parametrizar/buroCredito/consultar/${idIntermediarioFinanciero}`).pipe(catchError(HandleHttpError));
  }

  saveParametrizacionBuro(body:any){
    return this._http.post(
      `${this.url}/parametrizar/buroCredito/guardarParametrizaciones`, body
    ).pipe(catchError(HandleHttpError));
  }

  updateParametrizacionBuro(body:any){
    return this._http.put(
      `${this.url}/parametrizar/buroCredito/actualizar`, body
    ).pipe(catchError(HandleHttpError));
  }
}
